import React, {Component} from 'react';
import '../css/Scan.css';
import QrReader from 'react-qr-reader';
import { url } from '../env.json';
const axios = require('axios');

class QRScanner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showCamera: this.props.showCamera,
            delay: 100,
            facingMode: 'environment',
            result: 'Loading QR Scanner...',
            status: 'Default',
            statusColor: 'green',
            resolution: 600,
            errMsgDisplay: 'none'
        }

        this.handleScan = this.handleScan.bind(this);
    }

    componentDidMount() {
        // console.log('mounted props are: ', this.props)
    }

    handleScan(data) {  
        // TODO: REFACTOR THIS REDUNDANCY
        if (this.props.scanType === 'checkout') {
            axios.post(url + '/checkoutScan', {
                'message': 'checkout',
                'userID': data,
                'location': this.props.vendorID
            })
            .then((resp) => {
                // console.log(resp.data);
                if (resp.data.status.includes('SUCCESS')) {
                    this.setState({
                        showCamera: false,
                        result: 'SUCCESS!',
                        statusColor: 'green'
                    })

                    this.props.showResult();

                    setTimeout(() => {
                        this.props.finishScan();
                        this.props.updateStats();
                    }, 2000)
                } else if (resp.data.error.includes('MAX')) {
                    this.setState({
                        showCamera: false,
                        result: "User cannot checkout anymore cups!",
                        statusColor: 'red'
                    })

                    this.props.showResult();

                    setTimeout(() => {
                        this.props.finishScan();
                        this.props.updateStats();
                    }, 3000)
                }
            })
            .catch((err) => {
                // console.log(err);
            })
        } else if (this.props.scanType === 'checkin') {
            axios.post(url + '/checkinScan', {
                'message': 'checkin',
                'userID': data,
                'location': this.props.vendorID
            })
            .then((resp) => {
                // console.log(resp.data);
                if (resp.data.includes("SUCCESS")) {
                    this.setState({
                        showCamera: false,
                        result: "SUCCESS!",
                        status: 'green'
                    })

                    this.props.showResult();

                    setTimeout(() => {
                        this.props.finishScan();
                        this.props.updateStats();
                    }, 2000);
                } else if (resp.data.includes("NO CUPS")) {
                    this.setState({
                        showCamera: false,
                        result: "User has no cups to return!",
                        statusColor: 'red'
                    })

                    this.props.showResult();

                    setTimeout(() => {
                        this.props.finishScan();
                        this.props.updateStats();
                    }, 3000)
                }
            })
        } else if (this.props.scanType === 'refill') { 
            axios.post(url + '/refillScan', {
                'message': 'refill',
                'userID': data,
                'location': this.props.vendorID
            })
            .then((resp) => {
                // console.log(resp.data);
                if (resp.data.includes("SUCCESS")) {
                    this.setState({
                        showCamera: false,
                        result: "SUCCESS!",
                        statusColor: 'green'
                    })

                    this.props.showResult();

                    setTimeout(() => {
                        this.props.finishScan();
                    }, 2000);
                }
            })
        }
    }

    handleError(err) {
        // OPTIONAL TODO: Send errors to DB
        console.log(err);
    }

    returnScanAction() {
        if (this.props.scanType === 'checkin') {
            return 'return'
        } else {
            return this.props.scanType
        }
    }

    renderScanner() {
        const previewStyle = {
            height: '300px',
            width: '300px',
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
            margin: '30px auto'
        }

        const switchBtnStyle = {
            padding: '5px 10px',
            fontSize: '100%'
        }

        return (
            <div>
                <p>Scan customer QR code to <strong>{this.returnScanAction()}</strong> a cup.</p>
                <button style={switchBtnStyle} onClick={() => {
                    if (this.state.facingMode === 'environment') {
                        this.setState({
                            facingMode: 'user'
                        })
                    } else if (this.state.facingMode === 'user') {
                        this.setState({
                            facingMode: 'environment'
                        })
                    }
                }}>Switch Camera</button>
                <QrReader
                    facingMode={this.state.facingMode}
                    delay={this.state.delay}
                    style={previewStyle}
                    onError={this.handleError}
                    onScan={this.handleScan}
                />
                <button onClick={() => { this.setState({ showCamera: 'manual' }) }} id="manual-scan-btn">Manual {this.returnScanAction()}</button>
                <button onClick={() => { this.props.cancelScan() }} className='cancel-scan-btn'>&lt; Cancel</button>
            </div>
        )
    }

    renderManualScan() {
        const inputMsgStyle = {
            color: 'red',
            fontWeight: '900',
            fontSize: '120%',
            padding: '5px',
            margin: '5px',
            display: this.state.errMsgDisplay
        }

        return (
            <div>
                <p>Enter customer ID to <strong>{this.returnScanAction()}</strong> a cup.</p>
                <img id="manual-scan-img" alt='' src="https://cuppy-assets.s3-us-west-2.amazonaws.com/logo-gray.png"/>
                <div id="user-id">USER ID</div>
                <div style={inputMsgStyle} id="vendor-manual-input-msg">Invalid user ID. Please try again.</div>
                <input id="userid-input" autoComplete="off" ref="userid" className="user-id-input" type="number" placeholder="E.g. 1234" name="userid" required></input>
                <button onClick={() => {
                    let userid = this.refs.userid.value;
                    
                    if (userid === '' | userid.length < 4) {
                        this.setState({
                            errMsgDisplay: 'block'
                        })
                    } else {
                        axios.post(url + '/verifyUserID', {
                            message: 'Verify User ID',
                            userid: userid
                        })
                        .then((resp) => {
                            if (resp.data.includes('EXIST')) {
                                this.setState({
                                    errMsgDisplay: 'none'
                                })

                                this.handleScan(userid);
                            } else {
                                this.setState({
                                    errMsgDisplay: 'block'
                                })
                            }
                        })
                    }
                }} id="confirm-manual-scan-btn">{this.returnScanAction()}</button>
                <button onClick={() => { this.props.cancelScan() }} className="cancel-scan-btn">&lt; Cancel</button>
            </div>
        )
    }

    renderScanStatus() {
        const scanStatusResults = {
            fontSize: '150%',
            fontWeight: 'bold',
            height: '150px',
            width: '300px',
            margin: '20px auto',
            color: this.state.statusColor,
            verticalAlign: 'middle'
        };

        return (
            <div style={scanStatusResults}>
                {this.state.result}
            </div>
        )
    }

    render() {
        if (this.state.showCamera === true) {
            return this.renderScanner();
        } else if (this.state.showCamera === 'manual') {
            return this.renderManualScan();
        } else if (this.state.showCamera === false) {
            return this.renderScanStatus();
        }
    }
}

export default class ScanPage extends React.Component {
    returnAction() {
        if (this.props.scanType === 'checkin') {
            return 'return'
        } else {
            return this.props.scanType
        }
    }

    render() {
        return (
            <div className='scan-page app-page'>
                <div className='scan-page-header'>{this.returnAction()}</div>
                <QRScanner
                    scanType = {this.props.scanType}
                    vendorID = {this.props.vendorID}
                    showCamera = {this.props.showCamera}
                    finishScan = {() => {this.props.cancelScan()}}
                    showResult = {() => {this.props.showResult()}}
                    updateStats = {() => {this.props.updateVendorStats()}}
                    cancelScan = {() => {this.props.cancelScan() }}
                />
                {/* <button onClick={() => { this.props.cancelScan() }} className='cancel-scan-btn'>&lt; Cancel</button> */}
            </div>
        )
    }
}